export const inputadornment = {
    base: {
        background: "white",
        color: "black",
        params: {
            padding: '0px 0px 0px 10px'
        }
    }
}